<app-link [url]="'https://wa.me/' + value" displayText="">
  <app-icon [src]="'assets/images/icons-svg/whats-app-icon.svg'" [size]="'18px'"></app-icon>
</app-link>
